module.exports = __webpack_public_path__ + "static/media/ic_mobile_horizontal.5d0eccc0.svg";